import { useCallback, useEffect, useMemo, useState } from 'react';
import { orderBy } from 'lodash';
import RSelect from 'components/atoms/formInputs/RSelect';
import { IRetailer } from 'shared/types';
import { useTranslation } from 'helpers/languages/translations';
import { useRetailers } from 'core/redux/selectors/dataSelectors';

const useRetailerMultiSelect = () => {
    const translate = useTranslation();
    const { retailers: retailersData, isLoading: isRetailerLoading, isError: isRetailerError } = useRetailers();
    const [retailerIds, setRetailerIds] = useState<(string | number)[]>([]);

    const retailersOptions = useMemo(
        () =>
            orderBy(
                retailersData?.map((ret: IRetailer) => ({ label: ret.name, value: ret.id })),
                'label',
            ) || [],
        [retailersData],
    );

    const RetailerMultiSelect = useCallback(
        () => (
            <RSelect
                options={retailersOptions}
                onChange={setRetailerIds}
                selectedOptions={retailerIds}
                placeholder={translate('retailerSelect') as string}
            />
        ),
        [retailersData],
    );

    return { RetailerMultiSelect, retailerIds };
};

export default useRetailerMultiSelect;
